import React, { Component } from 'react';
import { PlayButton, SimpleMarkdown } from '../../atoms';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} infoBlock
 * @prop {Boolean} expandedItemId
 * @prop {Function} setVideoId
 * @prop {Function} setExpandedItemId
 *
 * @augments {Component<Props>}
 */
// @ts-ignore
const READ_MORE_HEIGHT = 505;

export default class NewInfoBlock extends Component {

	/**
	 * @param {any} props
	 */
	constructor (props) {
		super(props);

		this.state = {
			hasReadMore: false,
		};
	}

	componentDidMount () {
		if (!this.newInfoBlockRef.current) return;
		if (this.newInfoBlockRef.current.scrollHeight > READ_MORE_HEIGHT) {
			// eslint-disable-next-line react/no-did-mount-set-state
			this.setState({ hasReadMore: true });
		}
	}

	/**
	 * @param {{ expandedItemId: number|null; }} nextProps
	 */
	UNSAFE_componentWillReceiveProps (nextProps) {
		if (!this.newInfoBlockRef.current) return;

		window.clearTimeout(this.timeout); // Clear timeout in case user click faster than 'animationDuration'
		const contentWrap = this.newInfoBlockRef.current;
		if (nextProps.expandedItemId === this.props.infoBlock.id) {
			contentWrap.style.height = `${contentWrap.scrollHeight}px`;
			this.timeout = window.setTimeout(() => {
				contentWrap.style.height = 'auto';
			}, 3000);
		} else {
			contentWrap.style.height = `${contentWrap.scrollHeight}px`;
			this.timeout = window.setTimeout(() => {
				contentWrap.style.height = '505px';
			}, 0);
		}
	}

	newInfoBlockRef = React.createRef();

	timeout = 0;

	handleExpandingText = (/** @type {any} */ itemId) => {
		this.props.setExpandedItemId(
			this.props.expandedItemId === itemId ? null : itemId
		);
	};

	render () {
		const { expandedItemId } = this.props;
		const {
			infoBlock: { media, title, content, createdData, categories, id },
			setVideoId,
		} = this.props;

		return (
			<div
				key={id}
				ref={this.newInfoBlockRef}
				className={`NewInfoBlock ${
					expandedItemId === id ? 'NewInfoBlockExpanded' : ''
				}`}
			>
				<div className='MediaContent'>
					{media.image && (
						<img
							className='ImageContainer'
							src={require(`../../../assets/images/${media.image.src}`)}
							alt={media.image.alt}
						/>
					)}
					{media.video && (
						<div className='VideoContainer'>
							<span className='VideoButton'>
								<PlayButton
									onClick={() => setVideoId(media.video)}
								/>
							</span>
							<img
								className='ScreenContainer'
								// @ts-ignore
								src={require(`../../../assets/images/new-laptop.jpg`)}
								alt={'video'}
							/>
						</div>
					)}
				</div>
				<div className='DescriptionContainer'>
					<div className='CategoryBlock'>
						<p className='CategoryValue'>
							{categories
								.map((/** @type {{ name: any; }} */ category) => category.name)
								.join(', ')}
						</p>
						<div className='CreatedDate'>{createdData}</div>
					</div>
					<div className='DescriptionTitle'>
						{title}
					</div>
					<p className='ReadMoreText'>
						<SimpleMarkdown>{content}</SimpleMarkdown>
					</p>
					{this.state.hasReadMore && (
						<label
							className='ReadMore'
							onClick={() => this.handleExpandingText(id)}
						>
							{expandedItemId === id ? 'Read Less' : 'Read more'}
						</label>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/molecules/NewInfoBlock/NewInfoBlock.js